import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AddPermissions from "./AddPermissions";
import EditPermission from "./EditPermission";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Context/AuthContext";
import TableComponent from "../../../utils/TableComponent";
import { Authorization } from "../../../Context/Authorization";

const ManagePermission = () => {
  const [permission, setPermission] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [currentState, setCurrentState] = useState(null);
  const { permissions } = useContext(AuthContext);
  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const Confiq = Authorization();

        const response = await axios.get(
          `${Api}/api/users/permissions`,
          Confiq
        );
        setPermission(response.data);
      } catch (err) {
        console.error("Error fetching data", err);
      }
    };

    fetchPermissions();
  }, []);

  const handleShowAddPopup = () => {
    setShowAddPopup(true);
  };

  const handleCloseAddPopup = () => {
    setShowAddPopup(false);
  };

  const handleShowEditPopup = (permission) => {
    setCurrentState(permission);
    setShowEditPopup(true);
  };

  const handleCloseEditPopup = () => {
    setShowEditPopup(false);
    setCurrentState(null);
  };

  const handleDeletePermission = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Permission?"
    );
    if (!confirmDelete) {
      return;
    }
    try {
      const Confiq = Authorization();

      await axios.delete(`${Api}/api/users/permissions/${id}`, Confiq);
      setPermission(permission.filter((perm) => perm._id !== id));
      toast.success("Deleted Successfully");
    } catch (err) {
      console.error("Error deleting permission", err);
    }
  };

  const handleAddPermission = (newPermission) => {
    setPermission([...permission, newPermission]);
  };

  const columns = [
    {
      headerName: "SI.No",
      field: "index",
      valueGetter: (params) => params.node.rowIndex + 1,
    },
    {
      headerName: "Permission Name",
      field: "permissionName",
    },
    {
      headerName: "Description",
      field: "description",
    },
    {
      headerName: "Action",
      field: "action",
      cellRenderer: (params) => {
        return (
          <div>
            {permissions.includes("EditPermissions") && (
              <i
                className="mdi mdi-pen"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => handleShowEditPopup(params.data._id)}
              />
            )}
            {permissions.includes("DeletePermission") && (
              <i
                className="mdi mdi-delete"
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
                onClick={() => handleDeletePermission(params.data._id)}
              />
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="permissionContent">
      <div className="page-header">
        <h3 className="page-title"> Permissions </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Permissions
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            {permissions.includes("AddPermissions") && (
              <div className="Add_btn">
                <button
                  type="button"
                  className="btn btn-inverse-success"
                  onClick={handleShowAddPopup}
                >
                  Create New
                </button>
              </div>
            )}
            <div className="table-responsive">
              <TableComponent data={permission} columns={columns} />
            </div>
          </div>
        </div>
      </div>

      {showAddPopup && (
        <AddPermissions
          onClose={handleCloseAddPopup}
          onAddPermission={handleAddPermission}
        />
      )}
      {showEditPopup && currentState && (
        <EditPermission
          permission={currentState}
          onClose={handleCloseEditPopup}
        />
      )}
    </div>
  );
};

export default ManagePermission;
